import React from 'react'
import {Redirect, Route} from "react-router";
import {LINK} from "../utils/Links";
import {LocalStorageApi} from "../utils/LocalStorageApi";

export const AuthorizedRoute = ({component: WrappedComponent, ...rest}: any) => {

    const czyZalogowany: boolean = LocalStorageApi.isAccessTokenExists();

    return <Route {...rest} render={props => {
        if (!czyZalogowany) {
            return <Redirect to={{pathname: LINK.SIGNIN, state: props.location.state}}/>
        } else {
            return <WrappedComponent {...props}/>
        }
    }}/>
};